// import {FC} from 'react'
// import {useLang} from './Metronici18n'
// import {IntlProvider} from 'react-intl'
// import '@formatjs/intl-relativetimeformat/polyfill'
// import '@formatjs/intl-relativetimeformat/locale-data/en'
// import '@formatjs/intl-relativetimeformat/locale-data/de'
// import '@formatjs/intl-relativetimeformat/locale-data/es'
// import '@formatjs/intl-relativetimeformat/locale-data/fr'
// import '@formatjs/intl-relativetimeformat/locale-data/ja'
// import '@formatjs/intl-relativetimeformat/locale-data/zh'

// // import enMessages from './messages/en.json'
// // import uzMessages from './messages/uz.json'
// // import ruMessages from './messages/ru.json'
// // import {WithChildren} from '../helpers'

// // const allMessages = {
// //   en: enMessages,
// //   uz: uzMessages,
// //   ru: ruMessages,
// // }

// // const I18nProvider: FC<WithChildren> = ({children}) => {
// //   const locale = useLang()
// //   const messages = allMessages[locale]  

  
// //   return (
// //     <IntlProvider locale={locale} messages={messages}>
// //       {children}
// //     </IntlProvider>
// //   )
// // }

// // export {I18nProvider}

import { FC, useEffect, useState } from 'react'
import { useLang } from './Metronici18n'
import { IntlProvider } from 'react-intl'
import { WithChildren } from '../helpers'
import { fetchData } from '../../reusable'
import { useNavigate } from 'react-router-dom'

const I18nProvider: FC<WithChildren> = ({ children }) => {
  const locale = useLang()
  const [messages, setMessages] = useState<any>(null)
  useEffect(() => {
    if(locale){
      const fetchMessages = async () => {
        try {
          const param = {
            code: locale
          }          
          const response = await fetchData('admin/language', param)                                        
          
          setMessages(response)
          
        } catch (err) {
          setMessages({})
        }
      }
      fetchMessages()
    }
  }, [locale])

  return (
    <IntlProvider locale={locale} messages={messages} onError={(err) => {
      if (
        process.env.NODE_ENV === 'development' &&
        err.code === 'MISSING_TRANSLATION'
      ) {
        // console.warn('[Missing translation]', err.message);
      }
    }}>
      {children}
    </IntlProvider>
  )
}

export { I18nProvider }